export const getAspectRatio = ({ height, style, width, }) => {
    const widthString = width || style.width;
    const heightString = height || style.height;
    if (widthString && heightString) {
        const newWidth = Number.parseFloat(widthString);
        const newHeight = Number.parseFloat(heightString);
        return newWidth / newHeight;
    }
    const aspectRatioString = style.aspectRatio;
    if (aspectRatioString) {
        const [newWidth, newHeight] = aspectRatioString
            .split('/')
            .map((num) => Number.parseFloat(num.trim()));
        return newWidth / newHeight;
    }
    return 16 / 9;
};
//# sourceMappingURL=getAspectRatio.js.map